import { render, staticRenderFns } from "./TaskGroupTaskItem.vue?vue&type=template&id=a82d6fc8&"
import script from "./TaskGroupTaskItem.vue?vue&type=script&lang=js&"
export * from "./TaskGroupTaskItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports